import { Schema } from "effect"
import { HttpApiEndpoint, HttpApiGroup } from "effect/http-api"
import { Authentication } from "./AuthApi.ts"
import { ProviderUnavailable } from "./Errors.ts"

export const BrokerStatus = Schema.Struct({
  provider: Schema.String,
  /** False when no app credentials are configured on the server. */
  configured: Schema.Boolean,
  connected: Schema.Boolean,
  accountName: Schema.NullOr(Schema.String),
  /** When the current access token stops working (epoch seconds). */
  expiresAt: Schema.NullOr(Schema.Number)
})
export type BrokerStatus = typeof BrokerStatus.Type

export class BrokersApi extends HttpApiGroup.make("brokers")
  .add(
    HttpApiEndpoint.get("status", "/status", { success: Schema.Array(BrokerStatus) }),
    // Returns the broker login URL; the browser navigates there, and the broker
    // redirects back to /api/brokers/fyers/callback (a plain route, not part of this API).
    HttpApiEndpoint.post("connectFyers", "/fyers/connect", {
      success: Schema.Struct({ url: Schema.String }),
      error: ProviderUnavailable
    })
  )
  .middleware(Authentication)
  .prefix("/brokers")
{}
